import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { isMobile } from 'react-device-detect'
import { useNavigate } from 'react-router-dom'

import CloseIcon from 'client/utils/icons/close-icon'
import PencilIcon from 'client/utils/icons/pencil-icon'
import PlusIcon from 'client/utils/icons/plus-icon'
import RefreshIcon from 'client/utils/icons/refresh-icon'
import TrashIcon from 'client/utils/icons/trash-icon'
import {
  DcButton,
  DcDiv,
  DcDropDown,
  DcFlexBox,
  DcInput,
  DcOverlaySlider,
  DcSwitch,
  DcText,
  Link,
  PixelDate,
  PixelDiv,
  PixelFactoryContext,
  PixelFlexBox,
  PixelImage,
  PixelPageContainer,
  PixelSpinner,
  PixelTable,
  PixelText,
  Section,
  SectionActions,
  SectionContent,
  SectionHeader,
  SectionTitle,
} from 'pixel-base'
import { AjaxResponseType } from 'rxjs/internal/ajax/types'
import { AjaxResponse } from 'rxjs-compat'
import {
  COURIER_COMPANIES,
  deleteCourier,
  get,
  post,
  unmapPickupAddress,
  updateCourierStatus,
} from 'utils/api-routes.util'
import CheckIcon from 'utils/icons/check-icon'
import XmarkIcon from 'utils/icons/xmark-icon'

import AddRiderForm from './components/AddRiderForm'
import EditCourierCredential from './components/EditCourierCredential'
import EditCourierInfo from './components/EditCourierInfo'
import MapWarehouse from './components/MapWarehouse'
import {
  IPaymentGateway,
  IPaymentMethod,
  IPixelFactory,
  ICourierCompanies,
  IRider,
  ICourierField,
  WarehousePickup,
} from '../../../../../decl.d'

export interface ICourierDetail {
  tenant_name: string
  courier_id: number | null
  courier_name: string
  courier_username: null
  courier_company: ICourierCompany
  courier_type: ICourierType
  courier_cos_centre: null
  courier_origin_city: null
  is_active: boolean
  is_deleted: null
  payment_gateway_id: null
}

export interface ICourierCompany {
  id: number | null
  name: string
  image_path: string
}

export interface ICourierType {
  courier_type_id: number | null
  courier_type: string
  courier_type_description: string
}
interface IResponse {
  error?: string
  success?: boolean
}
export interface IPickupAddress {
  id: number | null
  source_pickup_id: string
  person_of_contact: string
  phone_number: string
  email_address: string
  warehouse: null
  address: string
  city: string
  status: string
  default: boolean
  is_deleted: null
}
export interface ICourierCost {
  ems_customer_id?: number
  cost_term?: string
  cost_term_type?: string
  cost_term_description?: string
  is_inevitable_flag?: boolean
  charges?: number
  lower_limit?: number
  upper_limit?: number
}
const CourierDetails = (props) => {
  const {
    readApi,

    courierId,
    setShowDetailModal,
  } = props
  const navigate = useNavigate()
  const courierDetailsRef = React.useRef(null)
  const pickupAddressRef = React.useRef(null)
  const oneLogisticsRef = React.useRef(null)
  const ridersRef = React.useRef(null)
  const {
    // showLoader,
    hideLoader,
    showSuccess,
    showFailure,
    pixelConfirm,
    showPageLoader,
    hidePageLoader,
  } = React.useContext<IPixelFactory>(PixelFactoryContext)

  const [courierDetails, setCourierDetails] = React.useState<ICourierDetail>({
    tenant_name: '',
    courier_id: null,
    courier_name: '',
    courier_username: null,
    courier_company: {
      id: 61,
      name: 'One Logistics',
      image_path: '',
    },
    courier_type: {
      courier_type_id: null,
      courier_type: '',
      courier_type_description: '',
    },
    courier_cos_centre: null,
    courier_origin_city: null,
    is_active: false,
    is_deleted: null,
    payment_gateway_id: null,
  })

  const [oneLogistics, setOneLogistics] = React.useState([])
  const [courierTypes, setCourierTypes] = React.useState([])
  const [courierCompanies, setCourierCompanies] = React.useState<
    ICourierCompanies[]
  >([])
  const [paymentGateways, setPaymentGateways] = React.useState<
    IPaymentGateway[]
  >([])
  const [showEditModalCredential, setShowEditModalCredential] =
    React.useState(false)
  const [showEditModal, setShowEditModal] = React.useState(false)
  const [showEditModalCourier, setShowEditModalCourier] = React.useState(false)
  const [fields, setFields] = React.useState([])
  const [riders, setRiders] = React.useState<IRider[]>([])
  const [showPopup, setShowPopup] = React.useState(false)
  const [showMapModel, setShowMapModel] = React.useState(false)
  const [pickupAddress, setPickupAddress] = React.useState<IPickupAddress[]>([])
  const [courierCostLines, setCourierCostLines] = React.useState([])
  const [selectedCostTermType, setSelectedCostTermType] = React.useState('')
  const [charges, setCharges] = React.useState('')
  const [lowerLimit, setLowerLimit] = React.useState('')
  const [upperLimit, setUpperLimit] = React.useState('')
  const [costTerm, setCostTerm] = React.useState('')
  const [costTermDescription, setCostTermDescription] = React.useState('')
  const [isInevitableFlag, setIsInevitableFlag] = React.useState(false)
  const [isShowSpinner, setIsShowSpinner] = React.useState(false)

  const [error, setError] = React.useState({
    error: '',
    field: '',
  })

  const [selectedAddress, setSelectedAddress] = React.useState<IPickupAddress>({
    id: null,
    source_pickup_id: '',
    person_of_contact: '',
    phone_number: '',
    email_address: '',
    warehouse: null,
    address: '',
    city: '',
    status: '',
    default: false,
    is_deleted: null,
  })

  React.useEffect(() => {
    getAllCourierTypes()
    getAllCourierCompanies()
    getAllPaymentGateways()
  }, [])
  const getData = () => {
    setIsShowSpinner(true)
    get('/courier/logistics/pickup-addresses').subscribe((res) => {
      setIsShowSpinner(false)
      const responseData = res.response as {
        data: IResponse | []
      }
      setOneLogistics(responseData?.data)
    })
  }
  React.useEffect(() => {
    if (
      courierDetails.courier_id &&
      courierDetails?.courier_company?.id == COURIER_COMPANIES.one_logistics
    )
      getData()
  }, [courierDetails])

  const getPickupAddress = (courierId) => {
    get(`/courier/pickup-address/${courierId}`).subscribe((res) => {
      const response = res.response as {
        data: IPickupAddress[]
      }
      if (response.data) {
        hideLoader(pickupAddressRef)
        const pickupAddress = response.data
        setPickupAddress(pickupAddress)
      } else {
        hideLoader(pickupAddressRef)
        showFailure('Something went wrong')
      }
    })
  }
  const syncPickupAddress = (courierId) => {
    showPageLoader()
    get(`/courier/pickup-address/sync/${courierId}`).subscribe((res) => {
      hidePageLoader()
      const response = res.response as {
        error: string
        data: IPickupAddress[]
      }
      if (response.error) {
        showFailure(response.error)
      } else {
        showSuccess('Pickup addresses synced successfully')
      }
      const pickupAddress = response.data
      setPickupAddress(pickupAddress || [])
    })
  }
  React.useEffect(() => {
    getPickupAddress(courierId)
  }, [courierId])
  const readData = (id, companies) => {
    // showLoader(courierDetailsRef)
    setIsShowSpinner(true)
    get(`/settings/couriers/${id}`).subscribe((res) => {
      const response = res.response as {
        data: ICourierDetail
      }
      if (response.data) {
        // hideLoader(courierDetailsRef)
        setIsShowSpinner(false)
        const courier = response.data
        if (courier.courier_type.courier_type === 'internal') {
          getRiders()
        }
        setCourierDetails(courier)
        const company = companies?.find(
          (company: ICourierCompanies) => company.id == courier?.company_id,
        )
        let allFields = []
        for (const key in company?.schema?.types) {
          if (company.schema.types[key].length !== 0 && key !== 'series') {
            allFields = allFields.concat(company.schema.types[key])
          }
        }
        setFields(allFields)
      } else {
        hideLoader(courierDetailsRef)
        showFailure('Something went wrong')
      }
    })
  }

  const getAllCourierTypes = () => {
    get('/settings/couriers/types').subscribe((res) => {
      const response = res.response as {
        data: ICourierType[]
      }
      setCourierTypes(response.data)
    })
  }

  const getAllCourierCompanies = () => {
    get('/settings/couriers/companies').subscribe((res) => {
      const response = res.response as {
        data: ICourierCompanies[]
      }
      const companies = response.data
        .map((c) => {
          c['slug'] = c.name.replace(/\s+/g, '-').toLowerCase()
          return c
        })
        .filter((c) => {
          return !!c.schema
        })
      setCourierCompanies(companies)
      if (courierId) {
        readData(courierId, companies)
      }
    })
  }

  const getAllPaymentGateways = () => {
    get('/settings/payment-gateways').subscribe((res) => {
      const response = res.response as { data: IPaymentMethod[] }
      setPaymentGateways(response.data)
    })
  }

  const handleSetDataInEdit = (data) => {
    setShowEditModal(false)
    setShowEditModalCredential(false)
    setCourierDetails(data)
  }

  const updateStatus = (e) => {
    const postData = {
      is_active: e.target.checked,
    }
    // showLoader(courierDetailsRef)
    updateCourierStatus(courierId, postData).subscribe((res) => {
      hideLoader(courierDetailsRef)
      if (res.response?.courier_id) {
        showSuccess('Successfully Updated')
        setCourierDetails(res.response)
        const company: ICourierCompanies = courierCompanies.find(
          (company: ICourierCompanies) =>
            company.id == res.response.data.company_id,
        )
        let allFields = []
        for (const key in company.schema.types) {
          if (company.schema.types[key].length !== 0 && key !== 'series') {
            allFields = allFields.concat(company.schema.types[key])
          }
        }
        setFields(allFields)
      } else {
        showFailure(res.response?.error)
        setError({ ...error, error: res.response?.error })
      }
    })
  }

  const handleDelete = () => {
    pixelConfirm({
      title: 'Delete Courier',
      message: 'Are you sure? you want to delete this courier.',
      onConfirm: () => {
        showPageLoader()
        deleteCourier(courierId).subscribe((res) => {
          const response = res.response as {
            deleted: boolean
            error: string
          }
          hidePageLoader()
          setShowDetailModal(false)
          readApi()
          if (response.deleted) {
            showSuccess('Courier deleted successfully')
            navigate('/admin/couriers')
          } else {
            showFailure(`Something went wrong, ${response.error}`)
          }
        })
      },
    })
  }

  const getRiders = () => {
    // showLoader(ridersRef)
    get(`/settings/couriers/${courierId}/riders`).subscribe((res) => {
      const response = res.response as {
        data: IRider[]
      }
      setRiders(response.data)
      hideLoader(ridersRef)
    })
  }

  const handleUnMapPickupAddress = (row) => {
    const data = {
      courier_id: params?.id,
      warehouse_id: row?.warehouse_id,
      source_pickup_id: row?.source_pickup_id,
    }
    pixelConfirm({
      title: 'Unmap Pickup Address',
      message: 'Are you sure? you want to unmap Pickup Address.',
      onConfirm: () => {
        showPageLoader()
        unmapPickupAddress(data).subscribe((res) => {
          hidePageLoader()
          const response = res.response as {
            data: IPickupAddress
            error: string
          }
          if (response?.data && response?.data?.id) {
            showSuccess(
              response?.message ?? 'Pickup Address un mapped successfully',
            )
            window.location.reload()
          } else {
            showFailure(`Something went wrong, ${response.error}`)
          }
        })
      },
    })
  }

  const RidersColumns = [
    {
      dataField: 'rider_id',
      name: 'Rider Id',
      sortable: true,
      selector: (row) => (row.rider_id ? row.rider_id : '--'),
    },
    {
      dataField: 'rider_name',
      name: 'Rider Name',
      selector: (row) => (row.rider_name ? row.rider_name : '--'),
      sortable: true,
    },
    {
      dataField: 'prefix',
      name: 'Prefix',
      sortable: true,
      selector: (row) => (row.prefix ? row.prefix : '--'),
    },
    {
      dataField: 'is_active',
      name: 'Is Active ?',
      sortable: true,
      selector: (row) => (row.is_active ? row.is_active : '--'),
    },
  ]

  const logisticColumns = [
    {
      dataField: 'warehouse_id',
      name: 'Warehouse Id',
      sortable: true,
      selector: (row) => (row.warehouse_id ? row.warehouse_id : '--'),
    },
    {
      dataField: 'address',
      name: 'Address',
      selector: (row) => (row.address ? row.address : '--'),
      sortable: true,
    },
  ]
  const columns = [
    {
      dataField: 'source_pickup_id',
      name: 'Pickup ID',
      sortable: true,
      width: '15%',
      selector: (row) => (row.source_pickup_id ? row.source_pickup_id : '--'),
    },
    {
      dataField: 'city',
      name: 'City',
      width: '10%',
      selector: (row) => (row.city ? row.city : '--'),
      sortable: true,
    },
    {
      dataField: 'address',
      name: <PixelText>Address</PixelText>,
      sortable: true,
      width: '25%',
      selector: (row) =>
        row.address ? <PixelText multiLine> {row.address}</PixelText> : '--',
    },
    {
      dataField: 'updated_at',
      name: <PixelText>Updated At</PixelText>,
      sortable: true,
      width: '10%',
      selector: (row) => <PixelDate value={row.updated_at} /> || '--',
    },
    {
      dataField: 'mappedwarehouse',
      name: <PixelText>Mapped Warehouse</PixelText>,
      sortable: true,
      width: '20%',
      selector: (row) => (
        <PixelFlexBox gap="15px">
          {row.warehouse_id && row.warehouse_id !== '0' ? (
            <Link
              onClick={() => {
                window.open(`/locations/warehouses/detail/${row.warehouse_id}`)
              }}
            >
              {row.warehouse_name}
            </Link>
          ) : (
            <PixelDiv padding="0px 0px 0px 30px">
              <PlusIcon
                tooltip="Location not mapped to a warehouse. Click to map."
                size={18}
                color="green"
                onClick={() => {
                  setSelectedAddress(row)
                  setShowMapModel(true)
                }}
              />
            </PixelDiv>
          )}
        </PixelFlexBox>
      ),
    },
    {
      dataField: 'return_pickup_code',
      name: <PixelText>Return ID</PixelText>,
      sortable: true,
      width: '10%',
      selector: (row) =>
        row.return_pickup_code ? (
          <OverlayTrigger
            placement={'top'}
            overlay={
              <Tooltip id={'tooltip-return'}>{row.return_address}</Tooltip>
            }
          >
            <PixelText>{row.return_pickup_code}</PixelText>
          </OverlayTrigger>
        ) : (
          <OverlayTrigger
            placement={'top'}
            overlay={
              <Tooltip id={'tooltip-empty-return'}>
                Return Address is same as Shipment Address
              </Tooltip>
            }
          >
            <PixelText>{row.source_pickup_id}</PixelText>
          </OverlayTrigger>
        ),
    },
    {
      sortable: true,
      width: '13%',
      selector: (row) =>
        row?.warehouse_id ? (
          <XmarkIcon
            size={18}
            color={'red'}
            tooltip="Unmap Warehouse Pickup Address"
            onClick={() => {
              setSelectedAddress(row)
              handleUnMapPickupAddress(row)
            }}
          />
        ) : (
          ''
        ),
    },
  ]
  const CourierColumns = [
    {
      dataField: 'cost_term_type',
      name: 'Cost Term Type',
      width: '25%',
      selector: (row) => (row.cost_term_type ? row.cost_term_type : '--'),
    },
    {
      dataField: 'charges',
      name: <PixelText>Charges</PixelText>,
      width: '25%',
      selector: (row) => row.charges_details?.[0]?.charges ?? '0',
    },
    {
      dataField: 'lower_limit',
      name: <PixelText>Weight Start Range</PixelText>,
      width: '25%',
      selector: (row) => row.charges_details?.[0]?.lower_limit ?? '0',
    },

    {
      dataField: 'upper_limit',
      name: <PixelText>Weight End Range</PixelText>,
      width: '25%',
      selector: (row) => row.charges_details?.[0]?.upper_limit ?? '0',
    },
  ]

  const handleAddButtonClick = (e) => {
    e.preventDefault()
    if (
      !selectedCostTermType ||
      !charges ||
      !lowerLimit ||
      !upperLimit ||
      !costTerm ||
      !costTermDescription
    ) {
      showFailure('Please enter all required information')
      return
    }
    if (!/^[A-Za-z\s]+$/.test(costTerm)) {
      showFailure('Invalid Term Type. Only alphabets and spaces are allowed.')
      return
    }

    if (!/^[A-Za-z\s]+$/.test(costTermDescription)) {
      showFailure(
        'Invalid Term Description. Only alphabets and spaces are allowed.',
      )
      return
    }

    const dataObject = {
      charges,
      cost_term_type: selectedCostTermType,
      lower_limit: lowerLimit,
      upper_limit: upperLimit,
      cost_term: costTerm,
      cost_term_description: costTermDescription,
      is_inevitable_flag: isInevitableFlag,
    }
    // setTableLoading(true)
    setIsShowSpinner(true)
    post(`/courier/${courierId}/cost-lines`, dataObject).subscribe((res) => {
      if (res.response && res.response.error) {
        if (res.response.error) {
          // setTableLoading(false)
          setIsShowSpinner(false)

          showFailure(res.response.error)
          setShowEditModalCourier(false)
        } else {
          setIsShowSpinner(false)

          showFailure('Something went wrong')
        }
      } else if (res.response) {
        setIsShowSpinner(false)

        setShowEditModalCourier(false)
        showSuccess('Successfully add cost line')
        getCourierCostLines(courierId)
      } else {
        showFailure('Something went wrong')
      }

      setShowEditModalCourier(false)
    })
  }
  const getCourierCostLines = (courierId) => {
    get(`/courier/${courierId}/cost-lines`).subscribe((res) => {
      // showPageLoader()
      if (res && res.response && res.response.data) {
        // hidePageLoader()
        const costLines = res.response.data

        const flattenedCostLines = [].concat(...costLines)

        setCourierCostLines(flattenedCostLines)
      } else {
        showFailure('Error: Failed to fetch courier cost lines')
      }
    })
  }
  React.useEffect(() => {
    if (courierId) {
      getCourierCostLines(courierId)
      readData(courierId, courierCompanies)
    }
  }, [courierId])
  const weightRangeOptions = [
    { label: '0', value: '0' },
    { label: '0.5', value: '0.5' },
    { label: '1.0', value: '1.0' },
    { label: '1.5', value: '1.5' },
    { label: '2.0', value: '2.0' },
    { label: '2.5', value: '2.5' },
    { label: '3.0', value: '3.0' },
    { label: '3.5', value: '3.5' },
    { label: '4.0', value: '4.0' },
    { label: '4.5', value: '4.5' },
    { label: '5', value: '5' },
  ]
  return (
    <>
      <PixelSpinner isShow={isShowSpinner} />

      <PixelPageContainer isMobile={isMobile} ref={courierDetailsRef}>
        <Section isMobile={isMobile}>
          <SectionHeader>
            <SectionTitle
              style={{
                marginBottom: '0px',
                display: 'flex',
                alignItems: 'flex-end',
                gap: '10px',
              }}
            >
              {courierDetails.courier_company && (
                <PixelImage
                  borderRadius="30px"
                  width="40px"
                  src={courierDetails.courier_company?.image_path}
                  alt=""
                />
              )}{' '}
              {courierDetails?.courier_id &&
                courierDetails.courier_company?.name}
            </SectionTitle>
            {courierDetails?.courier_company?.id !=
              COURIER_COMPANIES.one_logistics && (
              <DcFlexBox justifyContent="flex-end" height="auto" gap="5px">
                <DcDiv widht="100px">
                  <DcSwitch
                    className={'large'}
                    onChange={updateStatus}
                    label={courierDetails.is_active ? 'Active' : 'Inactive'}
                    checked={courierDetails.is_active}
                  />
                </DcDiv>
                <DcButton
                  size="sm"
                  onClick={() => {
                    setShowEditModal(true)
                  }}
                  variant="outline-primary"
                  withIcon={true}
                >
                  <PencilIcon size={16} />
                  <span>Edit Info</span>
                </DcButton>
                <DcButton
                  size="sm"
                  onClick={() => {
                    setShowEditModalCredential(true)
                  }}
                  variant="outline-primary"
                  withIcon={true}
                >
                  <PencilIcon size={16} />
                  <span>Edit Credentials</span>
                </DcButton>
                <DcButton
                  size="sm"
                  onClick={handleDelete}
                  variant="outline-secondary"
                  withIcon={true}
                >
                  <TrashIcon size={16} />
                  <span>Delete</span>
                </DcButton>
              </DcFlexBox>
            )}
          </SectionHeader>
          <SectionContent isMobile={isMobile}>
            <PixelDiv
              width="100%"
              style={{
                display: 'table',
                tableLayout: 'fixed',
                borderSpacing: '0',
                borderCollapse: 'collapse',
              }}
            >
              <PixelDiv
                width="40%"
                style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#8e959b',
                  display: 'table-cell',
                  verticalAlign: 'middle',
                }}
              >
                Account Status:
              </PixelDiv>
              <PixelDiv
                width="60%"
                style={{
                  fontSize: '16px',
                  fontWeight: '400',
                  color: '#8e959b',
                  display: 'table-cell',
                  verticalAlign: 'middle',
                }}
              >
                {courierDetails.is_active ? (
                  <CheckIcon color="green" size={16} />
                ) : (
                  <XmarkIcon color="red" size={16} />
                )}
              </PixelDiv>
            </PixelDiv>
            <PixelDiv
              width="100%"
              style={{
                display: 'table',
                tableLayout: 'fixed',
                borderSpacing: '0',
                borderCollapse: 'collapse',
              }}
            >
              <PixelDiv
                width="40%"
                style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#8e959b',
                  display: 'table-cell',
                  verticalAlign: 'middle',
                }}
              >
                Name:
              </PixelDiv>
              <PixelDiv
                width="60%"
                style={{
                  fontSize: '16px',
                  fontWeight: '400',
                  color: '#8e959b',
                  display: 'table-cell',
                  verticalAlign: 'middle',
                }}
              >
                {courierDetails.courier_name
                  ? courierDetails.courier_name
                  : '--'}
              </PixelDiv>
            </PixelDiv>
            <PixelDiv
              width="100%"
              style={{
                display: 'table',
                tableLayout: 'fixed',
                borderSpacing: '0',
                borderCollapse: 'collapse',
              }}
            >
              <PixelDiv
                width="40%"
                style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#8e959b',
                  display: 'table-cell',
                  verticalAlign: 'middle',
                }}
              >
                Payment Gateway:
              </PixelDiv>
              <PixelDiv
                width="60%"
                style={{
                  fontSize: '16px',
                  fontWeight: '400',
                  color: '#8e959b',
                  display: 'table-cell',
                  verticalAlign: 'middle',
                }}
              >
                {paymentGateways?.find(
                  (pg) => pg.id == courierDetails.payment_gateway_id,
                )?.title ?? '--'}
              </PixelDiv>
            </PixelDiv>
            <PixelDiv
              width="100%"
              style={{
                display: 'table',
                tableLayout: 'fixed',
                borderSpacing: '0',
                borderCollapse: 'collapse',
              }}
            >
              <PixelDiv
                width="40%"
                style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: '#8e959b',
                  display: 'table-cell',
                  verticalAlign: 'middle',
                }}
              >
                Courier Type:
              </PixelDiv>
              <PixelDiv
                width="60%"
                style={{
                  fontSize: '16px',
                  fontWeight: '400',
                  color: '#8e959b',
                  display: 'table-cell',
                  verticalAlign: 'middle',
                }}
              >
                {courierDetails.courier_type
                  ? courierDetails.courier_type.courier_type
                  : '--'}
              </PixelDiv>
            </PixelDiv>

            {fields &&
              fields.map((field: ICourierField, index: number) => {
                return (
                  <PixelDiv
                    key={index}
                    width="100%"
                    style={{
                      display: 'table',
                      tableLayout: 'fixed',
                      borderSpacing: '0',
                      borderCollapse: 'collapse',
                    }}
                  >
                    <PixelDiv
                      width="40%"
                      style={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#8e959b',
                        display: 'table-cell',
                        verticalAlign: 'middle',
                        // padding: '10px',
                        // backgroundColor: '#e9ecef',
                      }}
                    >
                      {field.field_name}
                    </PixelDiv>
                    <PixelDiv
                      width="60%"
                      style={{
                        fontSize: '16px',
                        fontWeight: '400',
                        color: '#8e959b',
                        display: 'table-cell',
                        verticalAlign: 'middle',
                        // padding: '10px',
                        // backgroundColor: '#e9ecef78',
                      }}
                    >
                      {courierDetails[field.field]
                        ? courierDetails[field.field]
                        : '--'}
                    </PixelDiv>
                  </PixelDiv>
                )
              })}

            {courierDetails?.series &&
              courierDetails.series?.map((s) => {
                return (
                  <>
                    <PixelDiv
                      width="100%"
                      style={{
                        display: 'table',
                        tableLayout: 'fixed',
                        borderSpacing: '0',
                        borderCollapse: 'collapse',
                      }}
                    >
                      <PixelDiv
                        width="40%"
                        style={{
                          fontSize: '16px',
                          fontWeight: '600',
                          color: '#8e959b',
                          display: 'table-cell',
                          verticalAlign: 'middle',
                        }}
                      >
                        Prefix - {s.series_id}
                      </PixelDiv>
                      <PixelDiv
                        width="60%"
                        style={{
                          fontSize: '16px',
                          fontWeight: '400',
                          color: '#8e959b',
                          display: 'table-cell',
                          verticalAlign: 'middle',
                        }}
                      >
                        {s.series_prefix ? s.series_prefix : '--'}
                      </PixelDiv>
                    </PixelDiv>
                    <PixelDiv
                      width="100%"
                      style={{
                        display: 'table',
                        tableLayout: 'fixed',
                        borderSpacing: '0',
                        borderCollapse: 'collapse',
                      }}
                    >
                      <PixelDiv
                        width="40%"
                        style={{
                          fontSize: '16px',
                          fontWeight: '600',
                          color: '#8e959b',
                          display: 'table-cell',
                          verticalAlign: 'middle',
                        }}
                      >
                        Start Number
                      </PixelDiv>
                      <PixelDiv
                        width="60%"
                        style={{
                          fontSize: '16px',
                          fontWeight: '400',
                          color: '#8e959b',
                          display: 'table-cell',
                          verticalAlign: 'middle',
                        }}
                      >
                        {s.series_begin ? s.series_begin : '--'}
                      </PixelDiv>
                    </PixelDiv>
                    <PixelDiv
                      width="100%"
                      style={{
                        display: 'table',
                        tableLayout: 'fixed',
                        borderSpacing: '0',
                        borderCollapse: 'collapse',
                      }}
                    >
                      <PixelDiv
                        width="40%"
                        style={{
                          fontSize: '16px',
                          fontWeight: '600',
                          color: '#8e959b',
                          display: 'table-cell',
                          verticalAlign: 'middle',
                        }}
                      >
                        End Number
                      </PixelDiv>
                      <PixelDiv
                        width="60%"
                        style={{
                          fontSize: '16px',
                          fontWeight: '400',
                          color: '#8e959b',
                          display: 'table-cell',
                          verticalAlign: 'middle',
                        }}
                      >
                        {s.series_end ? s.series_end : '--'}
                      </PixelDiv>
                    </PixelDiv>
                  </>
                )
              })}
          </SectionContent>
        </Section>
        <Section isMobile={isMobile}>
          <SectionActions
            style={{
              justifyContent: 'space-between',
              display: 'flex',
            }}
          >
            <SectionTitle>Pickup Address</SectionTitle>
            {courierDetails?.courier_company?.id !=
              COURIER_COMPANIES.one_logistics && (
              <DcButton
                size="sm"
                style={{
                  marginRight: '10px',
                  marginLeft: '10px',
                  marginBottom: '12px',
                }}
                onClick={() => {
                  syncPickupAddress(courierId)
                }}
                withIcon={true}
              >
                <RefreshIcon size={16} />
                <span>Fetch Pickup Addresses</span>
              </DcButton>
            )}
          </SectionActions>
          {courierDetails?.courier_company?.id !=
            COURIER_COMPANIES.one_logistics && (
            <SectionContent ref={pickupAddressRef}>
              {pickupAddress?.length !== 0 ? (
                <PixelTable columns={columns} data={pickupAddress} />
              ) : (
                <p style={{ textAlign: 'center', paddingTop: '12px' }}>
                  No Pickup Address Found
                </p>
              )}
            </SectionContent>
          )}
          {courierDetails?.courier_company?.id ==
            COURIER_COMPANIES.one_logistics && (
            <SectionContent ref={oneLogisticsRef}>
              {oneLogistics?.length !== 0 ? (
                <PixelTable columns={logisticColumns} data={oneLogistics} />
              ) : (
                <p style={{ textAlign: 'center', paddingTop: '12px' }}>
                  No Pickup Address Found
                </p>
              )}
            </SectionContent>
          )}
        </Section>
        {courierDetails.courier_type.courier_type === 'internal' && (
          <Section isMobile={isMobile}>
            <SectionActions
              style={{
                justifyContent: 'space-between',
                display: 'flex',
              }}
            >
              <SectionTitle>Riders</SectionTitle>
              <DcButton
                variant="outline-success"
                size="sm"
                style={{
                  marginRight: '10px',
                  marginLeft: '10px',
                  marginBottom: '12px',
                }}
                onClick={() => {
                  setShowPopup(true)
                }}
                withIcon={true}
              >
                <PlusIcon size={16} />
                <span>Add Rider</span>
              </DcButton>
            </SectionActions>
            <SectionContent ref={ridersRef}>
              <PixelTable columns={RidersColumns} data={riders} />
            </SectionContent>
          </Section>
        )}{' '}
        <Section isMobile={isMobile}>
          <SectionActions
            style={{
              justifyContent: 'space-between',
              display: 'flex',
            }}
          >
            <SectionTitle>Courier Cost Lines</SectionTitle>
            <DcButton
              variant="outline-primary"
              size="sm"
              style={{
                marginRight: '10px',
                marginLeft: '10px',
                marginBottom: '12px',
              }}
              onClick={() => {
                setShowEditModalCourier(true)
              }}
            >
              + Add Courier Cost
            </DcButton>
          </SectionActions>
          <SectionContent>
            <PixelTable
              // progressPending={tableLoading}
              columns={CourierColumns}
              data={courierCostLines}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
      {showEditModalCourier && (
        <DcOverlaySlider
          title={'Courier Cost'}
          isOpen={showEditModalCourier}
          onClose={() => setShowEditModalCourier(false)}
          width="50%"
        >
          <SectionContent>
            <form>
              <PixelFlexBox
                justifyContent="flex-end"
                gap="20px"
                flexDirection="column"
                height="55%"
              >
                <DcFlexBox height="auto" gap="5px">
                  <DcDiv
                    width="50%"
                    height="auto"
                    style={{
                      display: 'flex',

                      flexDirection: 'column',
                      alignItems: 'flexStart',
                    }}
                  >
                    <DcText
                      style={{
                        textAlign: 'left',

                        color: '#2e314a',
                        fontSize: '.875rem',
                        fontWeight: '500',
                        marginBottom: '.5rem',
                      }}
                    >
                      Cost Term
                    </DcText>
                    <DcInput
                      type="text"
                      name="cost_term"
                      placeholder="Cost Term"
                      required
                      onChange={(e) => {
                        setCostTerm(e.target.value)
                      }}
                      error={
                        (error.field === 'cost_term' && error.error !== '') ||
                        (costTerm && !/^[A-Za-z\s]+$/.test(costTerm)
                          ? 'Provided value is Invalid'
                          : null)
                      }
                    />
                  </DcDiv>
                  <DcDiv
                    width="50%"
                    height="auto"
                    style={{
                      display: 'flex',

                      flexDirection: 'column',
                      alignItems: 'flexStart',
                    }}
                  >
                    <DcText
                      style={{
                        textAlign: 'left',

                        color: '#2e314a',
                        fontSize: '.875rem',
                        fontWeight: '500',
                        marginBottom: '.5rem',
                      }}
                    >
                      Charges
                    </DcText>
                    <DcInput
                      type="number"
                      name="charges"
                      placeholder="Charges"
                      onChange={(e) => setCharges(e.target.value)}
                    />
                  </DcDiv>
                </DcFlexBox>
                <DcDiv
                  width="100%"
                  height="auto"
                  style={{
                    display: 'flex',

                    flexDirection: 'column',
                    alignItems: 'flexStart',
                  }}
                >
                  <DcText
                    style={{
                      textAlign: 'left',

                      color: '#2e314a',
                      fontSize: '.875rem',
                      fontWeight: '500',
                      marginBottom: '.5rem',
                    }}
                  >
                    Cost Term Description
                  </DcText>
                  <DcInput
                    required
                    type="text"
                    name="cost_term_description"
                    placeholder="Cost Term Description"
                    onChange={(e) => {
                      setCostTermDescription(e.target.value)
                    }}
                    error={
                      (error.field === 'cost_term_description' &&
                        error.error !== '') ||
                      (costTermDescription &&
                      !/^[A-Za-z\s]+$/.test(costTermDescription)
                        ? 'Provided value is Invalid'
                        : null)
                    }
                  />
                </DcDiv>
                <DcDiv
                  height="auto"
                  style={{
                    display: 'flex',

                    flexDirection: 'column',
                    alignItems: 'flexStart',
                  }}
                >
                  <DcText
                    style={{
                      textAlign: 'left',

                      color: '#2e314a',
                      fontSize: '.875rem',
                      fontWeight: '500',
                      marginBottom: '.5rem',
                    }}
                  >
                    Cost Term Type
                  </DcText>
                  <DcDropDown
                    options={[
                      { value: 'weight-base', label: 'Weight Base' },
                      { value: 'fixed', label: 'Fixed' },
                      { value: 'amount-base', label: 'Amount Base' },
                    ]}
                    value={selectedCostTermType}
                    onChange={(e) => setSelectedCostTermType(e.target.value)}
                    placeholder="Select Cost Term Type"
                  />
                </DcDiv>

                <DcDiv
                  height="auto"
                  style={{
                    display: 'flex',

                    flexDirection: 'column',
                    alignItems: 'flexStart',
                  }}
                >
                  <DcText
                    style={{
                      textAlign: 'left',

                      color: '#2e314a',
                      fontSize: '.875rem',
                      fontWeight: '500',
                      marginBottom: '.5rem',
                    }}
                  >
                    Weight Start Range
                  </DcText>
                  <DcDropDown
                    placeholder="Select Weight Start Range"
                    tabIndex={1}
                    error={
                      error.field === 'lower_limit' && error.error !== ''
                        ? error.error
                        : null
                    }
                    required
                    options={weightRangeOptions}
                    value={lowerLimit}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      const selectedStartRange = parseFloat(e.target.value)
                      const selectedEndRange = parseFloat(upperLimit)

                      if (selectedStartRange > selectedEndRange) {
                        setLowerLimit(e.target.value)
                        setUpperLimit(e.target.value)
                      } else {
                        setLowerLimit(e.target.value)
                      }
                    }}
                  />
                </DcDiv>
                <DcDiv
                  height="auto"
                  style={{
                    display: 'flex',

                    flexDirection: 'column',
                    alignItems: 'flexStart',
                  }}
                >
                  <DcText
                    style={{
                      textAlign: 'left',

                      color: '#2e314a',
                      fontSize: '.875rem',
                      fontWeight: '500',
                      marginBottom: '.5rem',
                    }}
                  >
                    Weight End Range
                  </DcText>
                  <DcDropDown
                    placeholder="Select Weight End Range"
                    tabIndex={2}
                    error={
                      error.field === 'upper_limit' && error.error !== ''
                        ? error.error
                        : null
                    }
                    required
                    options={weightRangeOptions.filter(
                      (option) =>
                        parseFloat(option.value) > parseFloat(lowerLimit),
                    )}
                    value={upperLimit}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      const selectedEndRange = parseFloat(e.target.value)
                      const selectedStartRange = parseFloat(lowerLimit)

                      if (selectedEndRange < selectedStartRange) {
                        setUpperLimit(e.target.value)
                        setLowerLimit(e.target.value)
                      } else {
                        setUpperLimit(e.target.value)
                      }
                    }}
                  />
                </DcDiv>

                <DcSwitch
                  name="is_inevitable_flag"
                  checked={isInevitableFlag}
                  onChange={(e) => setIsInevitableFlag(e.target.checked)}
                  label="Is Inevitable Flag"
                />
              </PixelFlexBox>
              &nbsp;
              <PixelFlexBox justifyContent="flex-end" gap="10px">
                <DcButton
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => {
                    setShowEditModalCourier(false)
                  }}
                  withIcon={true}
                >
                  <CloseIcon size={16} />
                  <span>Cancel</span>
                </DcButton>
                <DcButton
                  size="sm"
                  type="submit"
                  onClick={handleAddButtonClick}
                >
                  <PlusIcon size={16} />
                  <span>Add</span>
                </DcButton>
              </PixelFlexBox>
            </form>
          </SectionContent>
        </DcOverlaySlider>
      )}

      <DcOverlaySlider
        width="50%"
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        title={'Edit Courier Info'}
      >
        {showEditModal && (
          <SectionContent>
            <EditCourierInfo
              courierId={courierId}
              courier={courierDetails}
              handleClose={handleSetDataInEdit}
              courierTypes={courierTypes}
              courierCompanies={courierCompanies}
              paymentGateways={paymentGateways}
            />
          </SectionContent>
        )}
      </DcOverlaySlider>
      <DcOverlaySlider
        width="50%"
        isOpen={showEditModalCredential}
        onClose={() => setShowEditModalCredential(false)}
        title={'Edit Courier Credentials'}
      >
        {showEditModalCredential && (
          <SectionContent>
            <EditCourierCredential
              courierId={courierId}
              courier={courierDetails}
              handleClose={handleSetDataInEdit}
              courierTypes={courierTypes}
              courierCompanies={courierCompanies}
              paymentGateways={paymentGateways}
            />
          </SectionContent>
        )}
      </DcOverlaySlider>
      <DcOverlaySlider
        isOpen={showPopup}
        width="50%"
        onClose={() => setShowPopup(false)}
        title={'Add Rider'}
      >
        <SectionContent>
          <AddRiderForm
            courier_id={courierId}
            handleClose={(data: IRider) => {
              setRiders([data, ...riders])
              setShowPopup(false)
            }}
          />
        </SectionContent>
      </DcOverlaySlider>
      <DcOverlaySlider
        isOpen={showMapModel}
        width="50%"
        onClose={() => setShowMapModel(false)}
        title={'Map With Warehouse'}
      >
        <SectionContent>
          <MapWarehouse
            courierId={courierId}
            pickupAddress={selectedAddress}
            handleClose={(data: WarehousePickup) => {
              if (data) {
                const pickup = pickupAddress.map((item) => {
                  if (item.id === data.id) {
                    return data
                  }
                  return item
                })
                setPickupAddress(pickup)
                window.location.reload()
              }
              setShowMapModel(false)
            }}
          />
        </SectionContent>
      </DcOverlaySlider>
    </>
  )
}

export default CourierDetails
